.container {
  border-radius: 12px;
  background: #FFFFFF0A;
  border: 1px solid rgba(255, 255, 255, 0.12);
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(64px);
  padding: 0;
}
